import type { NodeLike } from "./tone";

/**
 * Every audio node must be registered here at creation time, so dispose() and
 * init-failure rollback can release them in reverse order of acquisition.
 *
 * Code review rule: a node created without going through register() is a defect.
 */
export class DisposeRegistry {
  private nodes: NodeLike[] = [];

  register<T extends NodeLike>(node: T): T {
    this.nodes.push(node);
    return node;
  }

  get size(): number {
    return this.nodes.length;
  }

  /** Disposes in reverse order of creation. Safe to call twice. */
  disposeAll(onError?: (error: unknown) => void): void {
    for (let i = this.nodes.length - 1; i >= 0; i -= 1) {
      const node = this.nodes[i];
      if (node === undefined) continue;
      try {
        node.dispose();
      } catch (error) {
        onError?.(error);
      }
    }
    this.nodes = [];
  }
}
